var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00CE3F;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 1024,
    height: 1024
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M873.5,335.7c-60.1,8.4-119.5,21.2-178.6,36c-58.8,15.6-117,34.1-174.3,56.6c-10.8,4.2-21.6,8.8-32.3,13.4 c-22.1-8.1-43.9-15.9-64.5-24.1c-19.7-7.9-40.1-17.1-51.8-25.7c0.1-0.1,0.1-0.2,0.2-0.2c10.4-10.2,28.8-20.2,47.9-27 c16.8-6.1,35.1-10.1,51.9-11.7c0.7,10.2,5.2,20,13.7,26.9c16.2,13,39.9,10.4,52.9-5.8c6-7.4,12.9-13.7,18.2-30.9 c1.1-5.3,2.1-9.9,1.7-16.1c-0.5-6.5-1.7-12.9-4.8-18.9c-6-12.7-14.8-18.7-21.5-22.9c-13.6-7.5-22.9-8.6-31.9-10.1 c-8.6-1-16.5-1.3-23.9-1.1c-29.7,1-56,6.8-82.5,15.5c-26.2,9.3-52.3,20.6-77.5,43.3c-6.2,5.7-12.3,12.7-17.8,20.6 c-5.8,9.6-12.2,21-12.9,37.5c-0.8,16.1,5.1,31.5,12,41.8c6.8,9.6,14.3,17,20.9,22c25.9,19.6,48.6,28.3,71.2,37.9 c-11.8,7.4-23.6,15-35.1,23.3c-26.1,19.2-51.5,41.8-71.9,72.8c-9.7,15.9-18.6,33.8-22,54.8c-3.5,20.8-1.4,43,5.1,62.8 c0.3,0.8,0.7,1.8,1.1,2.6l0.5,1c14.1,29.7,41.4,50.3,67.2,60.6c26.2,10.7,52,14.3,76.9,15.2c49.9,1.3,96.9-8.1,142.1-24.7 c22.6-8.4,44.7-18.8,66-32.6c21.1-14,42.2-30.9,58.8-57.2c8.1-13,14.9-28.9,17.1-46.7c2.3-17.7-0.4-36.5-6.9-52 c-13-31.5-34.7-50.9-54.9-66.9c-1.1-0.8-2.3-1.7-3.5-2.4l-0.4-0.3c-21-12-42-21.9-63-30.9c46.1-20.9,93.3-39.9,141.5-56.6 c55.9-20.5,113.1-37.3,170.6-53.5c6.4-1.8,10.8-8.1,9.8-14.9C887.7,339.8,880.9,334.6,873.5,335.7z M366.4,398.4 c0-0.1,0.1-0.2,0.2-0.2C366.4,398.8,366.3,398.8,366.4,398.4z M611.8,603.4c3.8,8.5,2.8,13.9-3,25.2c-13,22.6-48.5,44.8-83.4,58.2 c-35.6,14-75,22.2-111.8,21.7c-36,0.1-67.7-11.6-77.4-29.6c-5.5-16.4-3.8-33.1,7.5-52.6c11.8-19.9,30.6-39.4,52.3-56.5 c22-17.5,46.2-33.2,71.6-47.7c42,15.5,83,31.4,118.2,51.5C598.5,583.8,608.2,595.1,611.8,603.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9d4ad79ddf1a625d347a74a89c5fa72e.svg";
export { ForwardRef as ReactComponent };